/**
 * taxjustice v1.1.0
 * (c) 2019 Andreas Jøssang
 */

import $ from "jquery";
import { Reveal } from "foundation-sites";

$(document).foundation();

/**
 * called when loaded
 */
var ready = function () {

    // show menu
    document.getElementById("hamburger").addEventListener("click", function (e) {
        var hamburger = document.getElementById("hamburger");
        var menu = document.getElementById("menu");
        if (!hamburger.classList.contains('header__hamburger--open')) {
            hamburger.classList.add("header__hamburger--open");
            menu.classList.add("header__menu--visible");
        } else {
            hamburger.classList.remove("header__hamburger--open");
            menu.classList.remove("header__menu--visible");
        }

        return false;
    });

};

// call ready function when document is loaded
if (document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)) {
    ready();
} else {
    document.addEventListener("DOMContentLoaded", ready);
}
